import {enumType} from 'common/enumType';

export const ArchiveFileType = enumType({
   SOURCE: 'Source',
   DESTINATION: 'Destination',
   BOTH: 'Both',
});
